import { render, staticRenderFns } from "./CreateEnrollment.vue?vue&type=template&id=5d04a352&"
import script from "./CreateEnrollment.vue?vue&type=script&lang=js&"
export * from "./CreateEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports